// 인증 라우트 모듈 - /login 및 비인증 접근 가능한 화면. AuthLayout(centered + 워터마크 배경) 안에 nesting.
const routes = [
  {
    path: '/login',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/pages/auth/LoginPage.vue'),
        meta: { requiresAuth: false, title: 'login.title' },
      },
    ],
  },
  {
    // 공개 초대 수락(비로그인) - 메일 링크 {url}?token= 로 진입. requiresAuth:false.
    path: '/invite/accept',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        name: 'InviteAccept',
        component: () => import('@/pages/auth/InviteAcceptPage.vue'),
        meta: { requiresAuth: false, title: '초대 수락' },
      },
    ],
  },
  {
    // 공개 전자계약 서명(비로그인) - 메일 링크 {ect-sign-url}?token= 로 진입. A4 문서 폭이라 전용 풀폭 레이아웃.
    path: '/ect/sign',
    name: 'EctSign',
    component: () => import('@/pages/auth/EctSignPage.vue'),
    meta: { requiresAuth: false, title: '전자계약 서명' },
  },
  {
    // 비밀번호 재설정 요청(비로그인) - 이메일 입력 -> 재설정 링크 발송.
    path: '/forgot-password',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        name: 'ForgotPassword',
        component: () => import('@/pages/auth/ForgotPasswordPage.vue'),
        meta: { requiresAuth: false, title: '비밀번호 재설정' },
      },
    ],
  },
  {
    // 비밀번호 재설정 확정(비로그인) - 메일 링크 {url}?token= 로 진입.
    path: '/reset-password',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        name: 'ResetPassword',
        component: () => import('@/pages/auth/ResetPasswordPage.vue'),
        meta: { requiresAuth: false, title: '비밀번호 재설정' },
      },
    ],
  },
];

export default routes;
